export default __webpack_public_path__ + "static/media/cloudlinux.cf73eaff.svg";